import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import { makeFieldStyleSelector } from "../../selectors";
import { loadPostPage, removePost, searchPosts, setShowingPostId } from "../actions";
import { localStateSelector, makeForumOptionsSelector } from "../selectors";
import { type Forums } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector(TargetSelector.Entity);
  const forumOptionsSelector = makeForumOptionsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      canAdd: localState.forumOptions.length > 0,
      fieldStyle: fieldStyleSelector(state, props),
      forumId: localState.forumId,
      forumOptions: forumOptionsSelector(state, props),

      isEditMode: state.isEditMode,
      items: localState.posts,
      page: localState.page,
      screen: state.viewport.screen,
      searchText: localState.search,
      size: localState.size,
      status: localState.status,
      userId: appInfo.user?.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  load: (page: number, forumId: string | null) => dispatch(loadPostPage({ ...getEntityRef(props), page, forumId })),

  onAddClick: () => dispatch(setShowingPostId({ ...getEntityRef(props), ticketId: null })),
  onDeleteClick: (item: Forums.Post) => dispatch(removePost({ ...getEntityRef(props), ticketId: item.ticketId })),
  onItemClick: (item: Forums.Post) => dispatch(setShowingPostId({ ...getEntityRef(props), ticketId: item.ticketId })),
  onPageChanged: (page: number, size: number) => dispatch(loadPostPage({ ...getEntityRef(props), page, size })),
  onSearch: (searchText: string) => dispatch(searchPosts({ ...getEntityRef(props), search: searchText }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
